/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Admin-supplied [startAt, endAt] window used by `DrawQualification` when scope=CUSTOM_WINDOW. Both values are unix ms; endAt must be >= startAt; both must be finite (NaN/Infinity rejected at the API layer — direct Mongo writes bypass validation).
 * @export
 * @interface DrawQualificationCustomWindow
 */
export interface DrawQualificationCustomWindow {
    /**
     * Unix ms - inclusive window start
     * @type {number}
     * @memberof DrawQualificationCustomWindow
     */
    startAt: number;
    /**
     * Unix ms - inclusive window end
     * @type {number}
     * @memberof DrawQualificationCustomWindow
     */
    endAt: number;
}

/**
 * Check if a given object implements the DrawQualificationCustomWindow interface.
 */
export function instanceOfDrawQualificationCustomWindow(value: object): value is DrawQualificationCustomWindow {
    if (!('startAt' in value) || value['startAt'] === undefined) return false;
    if (!('endAt' in value) || value['endAt'] === undefined) return false;
    return true;
}

export function DrawQualificationCustomWindowFromJSON(json: any): DrawQualificationCustomWindow {
    return DrawQualificationCustomWindowFromJSONTyped(json, false);
}

export function DrawQualificationCustomWindowFromJSONTyped(json: any, ignoreDiscriminator: boolean): DrawQualificationCustomWindow {
    if (json == null) {
        return json;
    }
    return {
        
        'startAt': json['startAt'],
        'endAt': json['endAt'],
    };
}

export function DrawQualificationCustomWindowToJSON(json: any): DrawQualificationCustomWindow {
    return DrawQualificationCustomWindowToJSONTyped(json, false);
}

export function DrawQualificationCustomWindowToJSONTyped(value?: DrawQualificationCustomWindow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startAt': value['startAt'],
        'endAt': value['endAt'],
    };
}

